import React from "react";

export const DotLoader: React.FC = () => {
  return (
    <div className="flex space-x-2 justify-center items-center">
      <div className="w-4 h-4 bg-blue-700 rounded-full animate-bounce"></div>
      <div className="w-4 h-4 bg-blue-700 rounded-full animate-bounce delay-200"></div>
      <div className="w-4 h-4 bg-blue-700 rounded-full animate-bounce delay-400"></div>
    </div>
  );
};

export const SpinLoader: React.FC = () => {
  return (
    <div className="flex space-x-2 justify-center items-center">
      <div
        className="animate-spin rounded-full h-8 w-8 border-t-4 border-b-4 border-blue-700 align-middle"
        role="status"
      ></div>
    </div>
  );
};

export const PageLoader: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="w-12 h-12 border-4 border-[#0fa9a6] border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
};  